import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { DataPrivacyItem } from './constants';

type SectionProps = {
  item: DataPrivacyItem;
};

const Section: React.FC<SectionProps> = ({ item }) => {
  return (
    <Box display='flex' flexDirection='column'>
      <Typography
        fontSize={{
          xs: '20px',
          sm: '26px',
          md: '36px',
        }}
        fontWeight={500}
        lineHeight={{
          xs: '24px',
          sm: '30px',
          md: '44px',
        }}
        gutterBottom
        mb={{ sm: 4, md: 0 }}
      >
        {item.title}
      </Typography>
      <Typography fontSize='16px' fontWeight={400} lineHeight='24px'>
        {item.description}
      </Typography>
    </Box>
  );
};

export default Section;
